import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './globals.css';
import 'leaflet/dist/leaflet.css'; // Import Leaflet's CSS
import { cleanupServiceWorkers } from './sw-cleanup';
import AppProviders from './providers/AppProviders';

// ¡Antes de renderizar!
cleanupServiceWorkers();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);

(window as any).__hideBootlog__?.();
